import type { Notification } from "@prisma/client";
import { format } from "date-fns";
import { href, Link } from "react-router";
import { cn } from "~/utils/cn";
import { NotificationIcon, type NotificationData } from "~/utils/notifications";

export function NotificationItem({
  notification,
  className,
}: {
  notification: Notification;
  className?: string;
}) {
  const notifData = notification.data as NotificationData;
  return (
    <Link
      to={href("/notification/:notificationId", {
        notificationId: notification.id,
      })}
    >
      <div
        className={cn(
          "relative rounded border",
          !notification.isRead && "bg-brand-sky-50 border-brand-sky",
          className
        )}
      >
        <div className="flex items-center gap-3 py-4 pr-2 pl-4">
          <NotificationIcon
            data={notifData}
            eventName={notification.eventType}
          />
          <div className="body-sm-500">{notifData.header}</div>
          <div className="text-dark-300 mb-auto text-right text-xs whitespace-nowrap">
            {format(new Date(notification.createdAt), "MMM dd h:mm a")}
          </div>
        </div>
      </div>
    </Link>
  );
}
